import {Socket} from "phoenix";
import {LiveSocket} from "phoenix_live_view";
import QRCode from "qrcode";
import {GameCountdown} from "./game-countdown";
import {RankMotion} from "./rank-motion";
import './analytics-entry';
const csrfToken=document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
const liveSocket=new LiveSocket('/live',Socket,{params:{_csrf_token:csrfToken},hooks:{RankMotion,GameCountdown,JoinQR:{mounted(this:{el:HTMLElement}){const canvas=document.createElement('canvas');canvas.setAttribute('role','img');canvas.setAttribute('aria-label','QR code to join this Scam Rush game');this.el.appendChild(canvas);QRCode.toCanvas(canvas,this.el.dataset.url??'',{width:196,margin:2,color:{dark:'#152019',light:'#ffffff'}});}}}});
if(document.querySelector('[data-phx-main]'))liveSocket.connect();
document.getElementById('goodmail-demo-search')?.addEventListener('input',event=>{
  const query=(event.target as HTMLInputElement).value.trim().toLowerCase();
  let matches=0;
  document.querySelectorAll<HTMLElement>('#inbox-preview [data-mail-search]').forEach(email=>{
    email.hidden=!(email.dataset.mailSearch??'').includes(query);
    if(!email.hidden)matches++;
  });
  const empty=document.getElementById('goodmail-demo-empty');
  if(empty)empty.hidden=matches>0;
});
document.getElementById('room-code-form')?.addEventListener('submit',event=>{event.preventDefault();const code=(document.getElementById('room-code') as HTMLInputElement).value.trim();if(code)location.assign('/join/'+encodeURIComponent(code));});
